import { render, staticRenderFns } from "./ListOntologies.vue?vue&type=template&id=bd96e802&scoped=true"
import script from "./ListOntologies.vue?vue&type=script&lang=js"
export * from "./ListOntologies.vue?vue&type=script&lang=js"
import style0 from "./ListOntologies.vue?vue&type=style&index=0&id=bd96e802&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd96e802",
  null
  
)

export default component.exports